module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\"" + _vm._s(_vm.quote) + "\"")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0d3a1e12!./~/vue-loader/lib/selector.js?type=template&index=0!./dev/src/components/Quotes.vue
// module id = ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-0d3a1e12!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./dev/src/components/Quotes.vue
// module chunks = 0